import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VFadeTransition,
    {
      attrs: {
        "hide-on-leave": _vm.hideOnLeave,
        mode: "out-in",
        origin: "center",
        appear: "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "file-preview", attrs: { "data-qa": "file_preview" } },
        [
          _c(
            "div",
            {
              staticClass: "file-preview__wrapper",
              attrs: { "data-qa": "file_preview_wrapper" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "file-preview__image-wrapper",
                  attrs: { "data-qa": "file_preview_image_wrapper" },
                },
                [
                  _setup.previewSrc
                    ? _c("img", {
                        staticClass: "file-preview__image",
                        attrs: {
                          src: _setup.previewSrc,
                          "data-qa": "file_preview_image",
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(_setup.DeleteBtn, {
                staticClass: "file-preview__button-wrapper",
                on: {
                  click: function ($event) {
                    return _setup.emit("delete")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                VFadeTransition,
                { attrs: { mode: "out-in", origin: "center", appear: "" } },
                [
                  _c(_setup.StatusIcon, {
                    key: _vm.status,
                    staticClass: "file-preview__status-icon",
                    attrs: {
                      status: _vm.status,
                      "file-mime-type": _vm.file.type,
                      "progress-value": _vm.progressValue,
                    },
                    on: { click: _setup.handleClickStatusIcon },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VFadeTransition,
            { attrs: { mode: "out-in", origin: "center", appear: "" } },
            [
              _setup.descriptionData
                ? _c(
                    "div",
                    {
                      key: _vm.status,
                      staticClass: "pt-1 text-caption text-center",
                      class: _setup.descriptionData.classes,
                      attrs: { "data-qa": "file_preview_description" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.descriptionData.text) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }